import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      toastOptions={{
        classNames: {
          toast: "!bg-green-50 !text-black !border-green-200 !shadow-lg !rounded-none",
          title: "!text-black",
          description: "!text-black",
          error: "!bg-red-50 !text-red-900 !border-red-200 !shadow-lg !rounded-none",
        },
      }}
      {...props} />
  );
}

export { Toaster }
